import axios from 'axios'
import { apiv3Url } from "../../../../_metronic/_helpers";

//export const URL = `${apiUrl}:8888/user-service/user`
export const URLV3 = `${apiv3Url}/api/crm/notifications`

export const getAllNotifikasi = (type,tgl_fetch) => {
    return axios.get(`${URLV3}?type=${type}&tgl_fetch=${tgl_fetch}`)
}

export const markAllNotifikasiRead = () => {
    return axios.post(`${URLV3}/read-all`)
}
